/*******************************************************************************
 * Copyright 2026 Collaterate. All rights reserved.
 *******************************************************************************/

var SPINNERIMAGE = '/web3/build/storefront/images/spinner.gif';
var comet = new CometManager(comm);

var globalpageglobals = new PageGlobals();

/*
 * global controllers
 */

var globals = {
    setCUser: function (object) {
        globalpageglobals.set('cuser', object);
    },
    browser: {
        hasLocalStorage: function () {
            var test = 'tbg_localStorage_test';
            try {
                localStorage.setItem(test, test);
                localStorage.removeItem(test);
                return true;
            } catch (e) {
                return false;
            }
        }
    }
};

var searchController = {
    search: function (control) {
        var $container = $(control).parents('#productSearchContainer');
        var keyword = $container.find('.keywords input').val();
        var categoryId = $container.find('.categories select').val();
        var searchType = $container.find("input[name='SEARCHTYPE']").val();

        //
        var searchResultsURL = new JDURL(searchGlobals.searchResultsURL);
        searchResultsURL.appendParam('k', keyword);
        if (hasValue(categoryId) && categoryId > 0) {
            searchResultsURL.appendParam('c', categoryId);
        }
        if (hasValue(searchType)) {
            searchResultsURL.appendParam('s', searchType);
        }

        //
        gotoURL(searchResultsURL.getUrl());
    },
    checkEnter: function (event, control) {
        if (isEnterEvent(event)) {
            searchController.search(control);
        }
    }
};

var events = {
    USER_LOADED: 'userLoaded',
    userLoaded: function () {
    },
    USER_LOADED_LOGGED_IN: 'userLoadedLoggedIn',
    userLoadedLoggedIn: function () {
    },
    USER_LOADED_NOT_LOGGED_IN: 'userLoadedNotLoggedIn',
    userLoadedNotLoggedIn: function () {
    },
    USER_JUST_LOGGED_IN: 'userJustLoggedIn',
    userJustLoggedIn: function () {
    },
    SESSION_ERROR: 'sessionError',
    sessionError: function () {
    },
    FORM_EMAIL_SENT: 'formEmailSent',
    formEmailSent: function () {
    },
    FORM_EMAIL_ERROR: 'formEmailError',
    formEmailError: function () {
    },
    PRINT_FILE_UPLOADED: 'printFileUploaded',
    printFileUploaded: function () {
    },
    NEW_ACTIVITY_LOG_ENTRY: 'newActivityLogEntry',
    newActivityLogEntry: function () {
    },
    CART_ITEM_REMOVED: 'cartItemRemoved',
    cartItemRemoved: function () {
    },
    PROJECT_ITEMS_MOVED: 'projectItemsMoved',
    projectItemsMoved: function () {
    },
    USER_SHARING_CHANGED: 'userSharingChanged',
    userSharingChanged: function () {
    },
    PROJECTS_LOADED: 'projectsLoaded',
    projectsLoaded: function () {
    },
    PRICE_ADJUSTED: 'priceAdjusted',
    priceAdjusted: function () {
    },
    NOTIFICATION_COUNT_UPDATED: 'totalNotificationCountUpdated',
    totalNotificationCountUpdated: function () {
    },
    PENDING_REVIEW_LIST_UPDATED: 'pendingReviewListUpdated',
    pendingReviewListUpdated: function () {
    },
    NEEDS_PRINT_FILES_LIST_UPDATED: 'needsPrintFilesListUpdated',
    needsPrintFilesListUpdated: function () {
    },
    REQUIRES_ACTION_LIST_UPDATED: 'requiresActionListUpdated',
    requiresActionListUpdated: function () {
    },
    ORDER_LIST_UPDATED: 'orderListUpdated',
    orderListUpdated: function () {
    },
    ORDER_PAGE_LOADED: 'orderPageLoaded',
    orderPageLoaded: function () {
    },
    UPDATE_TOTALS: 'updateTotals',
    updateTotals: function () {
    },
    UPDATE_TOTALS_FOR_PAYMENT: 'updateTotalsForPayment',
    updateTotalsForPayment: function () {
    },
    CHECKOUT_CONTINUE_ENABLED: 'checkoutContinueEnabled',
    checkoutContinueEnabled: function () {

    },
    CHECKOUT_CONTINUE_DISABLED: 'checkoutContinueDisabled',
    checkoutContinueDisabled: function () {

    },
    CHECKOUT_ACCOUNT_PAGE_LOADED: 'checkoutAccountPageLoaded',
    checkoutAccountPageLoaded: function () {

    },
    CHECKOUT_SHIPPING_PAGE_LOADED: 'checkoutShippingPageLoaded',
    checkoutShippingPageLoaded: function () {

    },
    CHECKOUT_PAYMENT_PAGE_LOADED: 'checkoutPaymentPageLoaded',
    checkoutPaymentPageLoaded: function () {

    },
    CHECKOUT_CONFIRMATION_PAGE_LOADED: 'checkoutConfirmationPageLoaded',
    checkoutConfirmationPageLoaded: function () {

    },
    CHECKOUT_THANKYOU_PAGE_LOADED: 'checkoutThankYouPageLoaded',
    checkoutThankYouPageLoaded: function () {

    },
    RETURN_SUBMITTED: 'returnSubmitted',
    returnSubmitted: function () {

    },
    RETURN_SUBMIT_ERROR: 'returnSubmitError',
    returnSubmitError: function () {

    },

    // Stock product page variant photos (TTI-20903), raised from configureStockController.js. Each has a
    // matching collaterate:* CustomEvent carrying the payload: collaterate:productVariantChanged with
    // {variantId}, and collaterate:productVariantSelectIgnored with {variantId, reason}. Documented in
    // docs/theme/variant-images-theme-handoff.md.
    PRODUCT_VARIANT_CHANGED: 'productVariantChanged',
    productVariantChanged: function () {

    },
    PRODUCT_VARIANT_SELECT_IGNORED: 'productVariantSelectIgnored',
    productVariantSelectIgnored: function () {

    },

    // Stock product page decoration picker (TTI-24082), raised from configureStockController.js when the page loads
    // and on every change. collaterate:productDecorationChanged carries {decorations: [{locationId, decorationId,
    // imprintWidthInches, imprintHeightInches}], brandedLogoFileId}, what add to cart will send. Documented in
    // docs/theme/decorations-theme-handoff.md.
    PRODUCT_DECORATION_CHANGED: 'productDecorationChanged',
    productDecorationChanged: function () {

    },

    // Raised with each proof, cancelable: collaterate:productDecorationProof carries {image, photo, resolutionWarning,
    // logoWidthInches, logoHeightInches, proofs}, or {image: null} when there is none. A theme showing the proof in its
    // gallery, in place of `photo`, cancels it and the page does not show its own copy. With `updating: true` it comes at
    // once when new proofs are asked for, carrying only the photos still good for the new choice; on this bus that
    // early one is PRODUCT_DECORATION_PROOF_UPDATING, and PRODUCT_DECORATION_PROOF is raised only when proofs arrive.
    PRODUCT_DECORATION_PROOF: 'productDecorationProof',
    productDecorationProof: function () {

    },
    PRODUCT_DECORATION_PROOF_UPDATING: 'productDecorationProofUpdating',
    productDecorationProofUpdating: function () {

    },

    // Stock product quantity grid (TTI-24064), raised from configureStockController.js. QUOTED and ADDED each have a
    // matching collaterate:* CustomEvent carrying the payload: collaterate:productQuantityGridQuoted with
    // {lines: [{variantId, quantity, price}], total}, and collaterate:productQuantityGridAdded with
    // {projectId, lines: [{variantId, quantity, orderItemId}]}. ADD_FAILED carries nothing. Documented in
    // docs/theme/quantity-grid-theme-handoff.md.
    PRODUCT_QUANTITY_GRID_QUOTED: 'productQuantityGridQuoted',
    productQuantityGridQuoted: function () {

    },
    PRODUCT_QUANTITY_GRID_ADDED: 'productQuantityGridAdded',
    productQuantityGridAdded: function () {

    },
    PRODUCT_QUANTITY_GRID_ADD_FAILED: 'productQuantityGridAddFailed',
    productQuantityGridAddFailed: function () {

    },

    // Product discovery: the [[ product_recommendations ]], [[ semantic_search_* ]] and
    // [[ popular_searches ]] theme components. Raised from productDiscoveryAnalytics.js, except the
    // answer pair, which is raised from searchAnswer.js.
    //
    // This bus passes NO arguments to a listener, so each of these has a matching collaterate:*
    // CustomEvent carrying the payload. The bus is what a theme controller already listens on; the
    // CustomEvent is where the detail lives. Both are documented in
    // docs/theme/product-discovery-theme-handoff.md.
    SEARCH_RESULTS_VIEWED: 'searchResultsViewed',
    searchResultsViewed: function () {

    },
    RECOMMENDATIONS_VIEWED: 'recommendationsViewed',
    recommendationsViewed: function () {

    },
    RECOMMENDATION_SELECTED: 'recommendationSelected',
    recommendationSelected: function () {

    },
    SEARCH_FACET_SELECTED: 'searchFacetSelected',
    searchFacetSelected: function () {

    },
    SEARCH_ARTICLES_VIEWED: 'searchArticlesViewed',
    searchArticlesViewed: function () {

    },
    SEARCH_ARTICLE_SELECTED: 'searchArticleSelected',
    searchArticleSelected: function () {

    },
    POPULAR_SEARCH_SELECTED: 'popularSearchSelected',
    popularSearchSelected: function () {

    },
    // Raised from searchTypeahead.js, not the beacon: the selection happens in the dropdown's own
    // controller, and going direct to a product means the results page is no longer there to stand in
    // for it with searchResultsViewed. Detail rides collaterate:search:typeahead_select.
    SEARCH_TYPEAHEAD_SELECTED: 'searchTypeaheadSelected',
    searchTypeaheadSelected: function () {

    },
    SEARCH_ANSWER_LOADED: 'searchAnswerLoaded',
    searchAnswerLoaded: function () {

    },
    // The failure half of the pair above, and deliberately ONE event rather than several. The answer
    // endpoint collapses no_candidates, model_unavailable, a timeout and a transport failure into the
    // same empty result on purpose, so splitting them here would hand a listener a distinction the
    // response withheld.
    SEARCH_ANSWER_UNAVAILABLE: 'searchAnswerUnavailable',
    searchAnswerUnavailable: function () {

    },

    // Product discovery facets. SEARCH_FACETS_LOADED and SEARCH_INTERPRETATION_APPLIED are raised from
    // searchFacets.js; the last three are raised from productDiscoveryAnalytics.js when a shopper uses the
    // applied-filters bar. Each rides a collaterate:<value> CustomEvent whose detail is ids and counts only,
    // never the query text. Raised before the browser follows a link, as SEARCH_FACET_SELECTED is.
    // Documented in docs/theme/product-discovery-theme-handoff.md.
    SEARCH_FACETS_LOADED: 'searchFacetsLoaded',
    searchFacetsLoaded: function () {

    },
    SEARCH_INTERPRETATION_APPLIED: 'searchInterpretationApplied',
    searchInterpretationApplied: function () {

    },
    SEARCH_FILTER_REMOVED: 'searchFilterRemoved',
    searchFilterRemoved: function () {

    },
    SEARCH_FILTERS_CLEARED: 'searchFiltersCleared',
    searchFiltersCleared: function () {

    },
    SEARCH_SUGGESTION_ACCEPTED: 'searchSuggestionAccepted',
    searchSuggestionAccepted: function () {

    },

    //
    trigger: function (eventName, argArray) {
        if (this.isEventRegistered(eventName)) {
            var eventFunction = this[eventName];

            // eventFunction.apply(null, argArray);// would be nice, but args are not passed by jquery.connect wiring
            eventFunction();
        }
    },
    listen: function (eventName, functionOrObject, optionalFunctionName) {
        if (optionalFunctionName == null) {
            $.connect(this, eventName, functionOrObject);
        } else {
            $.connect(this, eventName, functionOrObject, optionalFunctionName);
        }
    },
    unlisten: function (eventName, object, functionName) {
        $.disconnect(this, eventName, object, functionName);
    },
    registerCustomEvent: function (eventName) {
        var success = false;
        if (hasValue(eventName)) {
            if (!this.isEventRegistered(eventName)) {
                this[eventName] = new Function();
                success = true;
            }
        }
        return success;
    },
    isEventRegistered: function (eventName) {
        return this[eventName] != null;
    }
};

var userNotificationStorage = {
    clearAllCached: function () {
        this.clearCachedPendingReview();
        this.clearCachedRequiresAction();
        this.clearCachedNeedsPrintFiles();
    },
    clearCachedPendingReview: function () {
        if (globals.browser.hasLocalStorage()) {
            localStorage.removeItem('userNotifications_pendingReview');
        }
    },
    clearCachedRequiresAction: function () {
        if (globals.browser.hasLocalStorage()) {
            localStorage.removeItem('userNotifications_requiresAction');
        }
    },
    clearCachedNeedsPrintFiles: function () {
        if (globals.browser.hasLocalStorage()) {
            localStorage.removeItem('userNotifications_needsPrintFiles');
        }
    }
};

var getCustomEmailFormSentEventName = function (emailFormName) {
    return emailFormName + '_customFormSentEvent';
};
var listenForCustomFormEmailSent = function (emailFormName, callbackFunction) {
    var customEmailFormSentEventName = getCustomEmailFormSentEventName(emailFormName);
    if (!events.isEventRegistered(customEmailFormSentEventName)) {
        events.registerCustomEvent(customEmailFormSentEventName);
    }
    if (events.isEventRegistered(customEmailFormSentEventName) && callbackFunction != null) {
        events.listen(customEmailFormSentEventName, callbackFunction);
    }
};

/*
Braintree hosted input text style defaults

See: https://developers.braintreepayments.com/reference/client-reference/javascript/v2/hosted-fields#internal-styling-properties
Allowed properties are:
    color, font, font-family, font-size, font-size-adjust, font-stretch, font-style, font-variant, font-variant-alternates,
    font-variant-caps, font-variant-east-asian, font-variant-ligatures, font-variant-numeric, font-weight, line-height,
    outline, opacity, text-shadow, transition, -moz-osx-font-smoothing, -moz-transition, -webkit-font-smoothing,
    -webkit-transition, -moz-tap-highlight-color, -webkit-tap-highlight-color
*/
window.inputStyles = {
    input: {
        'font-family': 'Helvetica Neue, arial, sans-serif',
        'font-size': '11px',
        color: '#666',
        'font-weight': 'normal',
        transition: 'color 1s linear'
    },
    ':focus': {
        color: '#000'
    }
};

/* 
 * Dev Note: cstorefrontsettings keeps its historical flat, comet-shaped field names here so the
 * ~40 existing readers of globalpageglobals.cstorefrontsettings do not all have to migrate in this
 * ticket. 
 */
var mapStorefrontSettings = function (siteSettings) {
    var features = siteSettings.features || {};
    var commerce = siteSettings.commerce || {};
    var branding = siteSettings.branding || {};
    var system = siteSettings.system || {};
    return {
        showPricing: commerce.showPricing,
        addToCartRedirectsToHome: commerce.addToCartRedirectsToHome,
        allowStockQuantityChangeFromCart: commerce.allowStockQuantityChangeFromCart,
        allowPodQuantityChangeFromCart: commerce.allowPodQuantityChangeFromCart,
        multipleProjectsEnabled: features.multipleProjectsEnabled,
        backorderEnabled: features.backOrderEnabled,
        allowOrderingForDivisions: features.divisionOrderingEnabled,
        useDivisionAddresses: features.divisionAddressesEnabled,
        reorderQuoteInitialAutoDeviceSwitchModeEnabled: features.reorderQuoteInitialAutoDeviceSwitchModeEnabled,
        showPromotionsFeatureInCart: commerce.showPromotionsFeatureInCart,
        useLedgerAccounts: commerce.useLedgerAccounts,
        ledgerAccountPolicy: { id: commerce.ledgerAccountPolicy },
        system: { id: system.supplierId },
        site: { name: branding.name }
    };
}

/*
 * Initialization
 */
$(function () {
    // init page
    window.tbg.apiV2({
        url: '/sites/v2/bootstrap',
        method: 'GET'
    }).then(function (content) {
        globals.setCUser(content.user);
        globalpageglobals.set('cstorefrontsettings', mapStorefrontSettings(content.siteSettings));
        globalpageglobals.set('cshippingsettings', content.shippingSettings);

        // one time firing of user load events.
        events.trigger(events.USER_LOADED);
        if (globalpageglobals.cuser == null) {
            events.trigger(events.USER_LOADED_NOT_LOGGED_IN);
        } else {
            events.trigger(events.USER_LOADED_LOGGED_IN);
        }
    }, function () {
        events.trigger(events.SESSION_ERROR);
    });

    $('.datepicker').datepicker({ showOn: 'focus' });
});
